export class WidgetModalState {
  id = '';
  action = '';
}